import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { completeGoogle } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/auth", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    completeGoogle(sessionId)
      .then(() => {
        // clear hash
        window.history.replaceState({}, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail || "Google sign-in failed");
        navigate("/auth", { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground flex items-center justify-center">
      <div className="text-center">
        <div className="w-20 h-20 mx-auto border border-primary rounded-md scan-line" />
        <div className="mt-6 font-display text-2xl tracking-tight">Securing session…</div>
        <div className="text-sm font-mono-tech text-muted-foreground mt-1">// verifying Google identity</div>
      </div>
    </div>
  );
}
